export const PLATFORMS = Object.freeze([
  {
    id: 'engagenet', name: 'Engagenet', monogram: 'E', color: '#4481eb',
    logo: require('@/assets/images/platform_switcher/engagenet.svg'), app_code: 'Engagenet',
  },
  {
    id: 'aic_one', name: 'AIC One', monogram: 'A', color: '#C8102E',
    logo: require('@/assets/images/aic_one/logos/aicone_logo_v3.svg'), app_code: 'Home',
  },
  {
    id: 'orcaa', name: 'Orcaa.ai', monogram: 'Or', color: '#0E7CC4',
    logo: require('@/assets/images/platform_switcher/orcaa_ai.svg'), app_code: 'Orcaa',
  },
  {
    id: 'x-verdict', name: 'X-Verdict', monogram: 'X', color: '#7C3AED',
    logo: require('@/assets/images/platform_switcher/x-verdict.svg'), app_code: 'x-verdict',
  },
  {
    id: 'complyon', name: 'ComplyOn', monogram: 'C', color: '#B45309',
    logo: require('@/assets/images/platform_switcher/complyon.svg'), app_code: 'complyon',
  },
  {
    id: 'complyon_onboard', name: 'Onboard', monogram: 'On', color: '#0F766E',
    logo: require('@/assets/images/platform_switcher/Onboardid.png'), app_code: 'complyon_onboard',
  },
  {
    id: 'workflow', name: 'Proba Workflows', monogram: 'PW', color: '#4338CA',
    logo: require('@/assets/images/platform_switcher/ProbaWorkflows.png'), app_code: 'Proba_workflows',
  },
  {
    id: 'proba', name: 'Proba Analytics', monogram: 'PA', color: '#BE123C',
    logo: require('@/assets/images/platform_switcher/proba-analytics.svg'), app_code: 'Proba_analytics',
  },
]);

export const PLATFORM_IDS = Object.freeze(PLATFORMS.map((platform) => platform.id));
export const FALLBACK_PLATFORM_COLOR = '#6B5F60';

const PLATFORMS_BY_ID = Object.freeze(
  PLATFORMS.reduce((map, platform) => {
    map[platform.id] = platform;
    return map;
  }, {})
);

const PLATFORM_NAME_TO_ID = Object.freeze({
  'aic one': 'aic_one',
  aic_one: 'aic_one',
  'orcaa ai': 'orcaa',
  orcaa: 'orcaa',
  orca: 'orcaa',
  engagenet: 'engagenet',
  'ic workbook': 'engagenet',
  'x verdict': 'x-verdict',
  xverdict: 'x-verdict',
  complyon: 'complyon',
  'comply on': 'complyon',
  'complyon onboard': 'complyon_onboard',
  complyon_onboard: 'complyon_onboard',
  onboard: 'complyon_onboard',
  onboardid: 'complyon_onboard',
  'proba workflows': 'workflow',
  workflows: 'workflow',
  workflow: 'workflow',
  'proba analytics': 'proba',
  proba: 'proba',
  analytics: 'proba',
});

export function get_platform_config(platform_id) {
  const key = String(platform_id);
  if (!Object.hasOwn(PLATFORMS_BY_ID, key)) {
    return null;
  }

  return Reflect.get(PLATFORMS_BY_ID, key);
}

export function platform_id_for_name(name) {
  const normalized = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!Object.hasOwn(PLATFORM_NAME_TO_ID, normalized)) {
    return null;
  }

  return Reflect.get(PLATFORM_NAME_TO_ID, normalized);
}
